module.exports = __webpack_public_path__ + "img/let-me-try.306b7cbb.png";